//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import VueMultiselect from "vue-multiselect";
// import qs from "qs";
import $ from 'jquery';
import { validationMixin } from "vuelidate";
import { required, requiredIf, email, numeric, helpers } from "vuelidate/lib/validators";
import storage from "local-storage-fallback";

import "vue-multiselect/dist/vue-multiselect.min.css";

export default {
    data() {
        return {

            success: false,

            localStorage: null,
            totalSteps: 3,
            activeStep: 1,

            isFormLoading: false,

            options: {
                use_cases: ["Internal Employee Communication", "Conversational", "Transactional", "Notification", "Marketing", "OTP", "Website", "Reminders", "Appointment Reminders", "Service Promotions", "Banking and Lending Institution Services", "Educational Services", "Financial", "Employment Service Referrals", "Health Services", "News and Content Alerts", "Non-Profit Messaging", "Political Messaging", "Product of Service Delivery", "Sweepstakes and Lotteries", "Other"],
                country_destination: ["United States", "Canada", "American Samoa", "Angola", "Argentina", "Australia", "Austria", "Bahrain", "Bangladesh", "Belgium", "Bolivia", "Brazil", "Brunei", "Bulgaria", "Cambodia", "Cape Verde", "Chile", "China", "Colombia", "Costa Rica", "Croatia", "Cuba", "Czech Republic", "Denmark", "Dominican Republic", "Equador", "Egypt", "El Salvador", "Federated States of Micronesia", "Fiji", "Finland", "France", "Germany", "Greece", "Grenada", "Guatemala", "Honduras", "Hong Kong", "Hungary", "India", "Indonesia", "Iran", "Ireland", "Israel", "Italy", "Japan", "Kazakhstan", "Kenya", "Kiribati", "Kosovo", "Kuwait", "Laos", "Liechtenstein", "Lithuania", "Luxembourg", "Macau", "Macedonia", "Malaysia", "Maldives", "Malta", "Marshall Islands", "Mauritius", "Mexico", "Mongolia", "Montenegro", "Myanmar", "Nauru", "Netherlands", "New Zealand", "Nicaragua", "Nigeria", "Norfolk Island", "Norway", "Pakistan", "Palau", "Papua New Guinea", "Paraguay", "Peru", "Phillipines", "Poland", "Portugal", "Puerto Rico", "Romania", "Russia", "Samoa", "Saudia Arabia", "Serbia", "Singapore", "Slovakia", "Slovenia", "Soloman Islands", "South Africa", "South Korea", "Spain", "Sri Lanka", "Sweden", "Switzerland", "Taiwan", "Tanzania", "Thailand", "Tonga", "Turkey", "Tuvalu", "Uganda", "Ukraine", "United Arab Emirates", "United Kingdom", "United States of America", "Uruguay", "Vanuatu", "Venezuela", "Vietnam", "Zimbabwe"]
            },
            helpText: {
                opt_in_collection: [
                    'See <a target="_blank" href="https://help.kudosity.com/s/article/USA-SMS-Call-To-Action-Example-Visuals#Verbal">verbal script examples</a> in Section 4',
                    'See <a target="_blank" href="https://help.kudosity.com/s/article/USA-SMS-Call-To-Action-Example-Visuals#Email">email script examples</a> in Section 3',
                    'See <a target="_blank" href="https://help.kudosity.com/s/article/USA-SMS-Call-To-Action-Example-Visuals">web template script examples</a> in Section 1',
                    'See <a target="_blank" href="https://help.kudosity.com/s/article/USA-SMS-Call-To-Action-Example-Visuals#Keyword">keyword template script examples</a> in Section 2'
                ],
                opt_in_steps: [
                    'Please provide a word for word template of your verbal script. See <a href="https://help.kudosity.com/s/article/USA-SMS-Call-To-Action-Example-Visuals#Verbal" target="_blank">verbal script examples</a>',
                    'Please provide a word for word template of your email script. See <a href="https://help.kudosity.com/s/article/USA-SMS-Call-To-Action-Example-Visuals#Email" target="_blank">email script examples</a>',
                    'Please provide a word for word template of your web script. See <a href="https://help.kudosity.com/s/article/USA-SMS-Call-To-Action-Example-Visuals" target="_blank">web script examples</a>',
                    'Please provide a word for word template of your keyword script. See <a href="https://help.kudosity.com/s/article/USA-SMS-Call-To-Action-Example-Visuals#Keyword" target="_blank">keyword script examples</a>'
                ]
            },
            form: {
                first_name: "",
                last_name: "",
                company_name: "",
                company_website: "",
                company_address: "",
                email: "",
                mobile: "",
                city: "",
                state: "",
                country: "",
                country_destination: "",
                zip: "",
                tfn_type: "new",
                tfn_number: "",
                estimated_volume: "",
                use_cases: [],
                summary_use_case: "",
                message_template: "",
                help_keyword: "",
                stop_keyword: "",
               info_keyword: "",
                is_marketing: "",
                previous_service: "",
                previous_service_content: "",
                previous_service_numbers: "",
                number_published: "",
                opt_in_collection: "",
                cta_url: "",
                opt_in_steps: "",
                attach_file: null,
                attach_url: null,
                timestamp: ''
            },

            uploadProgress: 0,
            uploadStatus: 'standby',
            uploadText: '',

        };
    },
    components: { VueMultiselect },
    mixins: [validationMixin],
    validations: {
        form: {
            first_name: { required },
            last_name: { required },
            company_name: { required },
            company_website: { required },
            company_address: { required },
            email: { required, email },
            mobile: {
                required,
                phone(phone) {
                    if (phone === "") return true;
                    const numericAndPlus = /^[+]?[0-9]+$/;
                    return numericAndPlus.test(phone)
                },
            },
            city: { required },
            state: { required },
            country: { required },
            country_destination: { required },
            zip: { required },
            tfn_type: { required },
            tfn_number: {
                required: requiredIf(function (form) {
                    return form.tfn_type === "existing";
                }),
            },
            estimated_volume: { required, numeric },
            use_cases: { required },
            summary_use_case: { required },
            message_template: { required },
            help_keyword: { required: false },
            stop_keyword: { required: false },
            info_keyword: { required: false },
            is_marketing: { required },
            previous_service: { required },
            opt_in_collection: { required },
            cta_url: {
                required: requiredIf(function (form) {
                    return ['Website / Web Form'].includes(form.opt_in_collection)
                })
            },
            attach_file: {
                required: requiredIf(function (form) {
                    return ['In App', 'Website / Web Form', 'In-Person Printed Form'].includes(form.opt_in_collection)
                }),
                type(file) {
                    if (!helpers.req(file)) return true;
                    if (!file) return false;
                    return ['image/png', 'image/jpg', 'image/jpeg'].includes(file.type);
                },
                size(file) {
                    if (!helpers.req(file)) return true;
                    if (!file) return false;
                    return file.size <= 10485760;
                }
            },
            opt_in_steps: { required },
            number_published: {
                required: requiredIf(function (form) {
                    return ['Short Code', 'Long Number'].includes(form.previous_service)
                }),
            },
        },
    },
    computed: {
        isOptional() {
            return true
        },
        
    },
    methods: {
       
        getCurrentTimestamp() {
            const date = new Date();

            const day = date.getDate();
            const month = date.getMonth() + 1;
            const year = date.getFullYear();
            const hour = date.getHours();
            const minute = date.getMinutes();
            const second = date.getSeconds();

            return `${month}/${day}/${year} ${hour}:${minute}:${second}`;

        },
        _classValid(field) {
            let _class = "";
            if (this.$v.form[field] && this.$v.form[field].$dirty) {
                _class += "is-dirty ";

                if (this.$v.form[field].$pending) {
                    _class += "is-loading ";
                    return _class;
                }
                if (this.$v.form[field].$invalid) {
                    _class += "is-invalid ";
                } else {
                    _class += "is-valid ";
                }
            }

            return _class;
        },
        checkStepFields(step) {
            let invalid = false;
            const stepFields = [
                ["first_name", "last_name", "company_name", "company_website", "company_address", "email", "mobile", "city", "state", "country", "zip","country_destination"],
                ["tfn_type", "tfn_number", "estimated_volume", "use_cases", "summary_use_case", "message_template"],
                ["is_marketing", "previous_service", "number_published", "opt_in_collection", "opt_in_steps", "cta_url", "attach_file"]
            ];

            let firstInvalid = null;

            const fields = stepFields[step - 1];

            if (fields) {
                for (let i = 0; i < fields.length; i++) {
                    if (this.$v.form[fields[i]].$invalid) {
                        if (!firstInvalid) firstInvalid = fields[i];
                        this.$v.form[fields[i]].$touch();
                        invalid = true;
                    }
                }
            }

            if (firstInvalid) {
                const firstInvalidElem = document.querySelector('form [name="' + firstInvalid + '"]');
                if (firstInvalidElem) {
                    firstInvalidElem.scrollIntoView({ behavior: 'smooth', block: 'start', inline: 'center' });
                    firstInvalidElem.focus();
                }
            }

            return !invalid;
        },
        goToStep(add) {
            const next = Math.min(Math.max(this.activeStep + add, 1), this.totalSteps);
            if (add > 0 && !this.checkStepFields(this.activeStep)) {
                return;
            }

            this.activeStep = next;
        },
        saveForm() {
            this.localStorage.setItem('tfn-form-save', JSON.stringify(this.form));
        },
        saveStart() {
            this.saveForm();
            window.location.reload();
        },
        startOver() {
            this.localStorage.setItem('tfn-form-save', '{}');
            window.location.reload();
        },
        attachFileHandler(event) {
            if (event.target.files && event.target.files.length > 0) {
                this.form.attach_file = event.target.files[0];
                this.$v.form.attach_file.$touch();
            }
        },
        async onSubmit() {

            const self = this;
            this.$v.form.$touch();

            if (this.$v.form.$invalid) {
                console.log('invalid form', this.$v.form);
                for (let i = 1; i <= this.totalSteps; i++) {
                    if (!this.checkStepFields(i)) {
                        console.log('invalid form step ' + i);
                        this.activeStep = i;
                        break;
                    }
                }
                console.log('return');
                return;
            }

            await self.goSubmit();

            // try {
            //     const token = await this.$recaptcha.execute("register_tfn");

            //     // send token to server alongside your form data
            //     this.isFormLoading = true;
            //     this.$axios({
            //         url: "/.netlify/functions/captcha",
            //         baseURL: "/",
            //         method: "POST",
            //         headers: {
            //             "Content-Type": "application/json; charset=utf-8",
            //             "Cache-Control": "no-cache, no-store, must-revalidate",
            //             Pragma: "no-cache",
            //             Expires: 0,
            //         },
            //         data: qs.stringify({
            //             token,
            //         }),
            //     }).then(function (response) {
            //         if (response?.data?.success && response?.data?.score > 0.5) {
            //             self.goSubmit();
            //         } else {
            //             console.error("Recaptcha low score:", response);
            //         }
            //     });
            // } catch (error) {
            //     console.error("Recaptcha error:", error);
            // }
        },
        async uploadFile(file) {

            const cloud = process.env.CLOUDINARY_NAME;
            const preset = process.env.CLOUDINARY_PRESET;
            const self = this;
            const url = `https://api.cloudinary.com/v1_1/${cloud}/upload`;
            const fd = new FormData();

            fd.append('upload_preset', preset);
            fd.append('tags', 'tfn_file');
            fd.append('file', file);

            let totalBytes = 0;

            try {
                const response = await this.$axios.post(url, fd, {
                    headers: {
                        'Content-Type': 'multipart/form-data',
                        'X-Requested-With': 'XMLHttpRequest'
                    },
                    onUploadProgress(progressEvent) {
                        const uploadProgress = (progressEvent.loaded * 100.0) / progressEvent.total;
                        self.uploadProgress = uploadProgress.toFixed(2);
                        self.uploadText = `Uploading ${self.uploadProgress}% ...`;
                        self.uploadStatus = 'uploading';

                        totalBytes = progressEvent.total;
                    }
                });

                self.form.attach_url = response.data.secure_url;
                self.uploadStatus = 'done';
                self.uploadText = `Uploaded successfully ${totalBytes}`;
                console.log(`Uploaded successfully ${totalBytes}`);
            } catch (error) {
                // Handle the error
                console.error(error);

                self.$nuxt.$loading.fail(error);
            }

        },
        async goSubmit() {

            this.$nuxt.$loading.start();
            this.isFormLoading = true;

            if (['In App', 'Website / Web Form', 'In-Person Printed Form'].includes(this.$v.form.opt_in_collection.$model) && !this.$v.form.attach_file.$invalid) {
                await this.uploadFile(this.form.attach_file);
            }

            await this.sendToZapier();

            this.isFormLoading = false;
            this.success = true;
            this.$nuxt.$loading.finish();
        },
        async sendToZapier() {
            delete this.form.attach_file;
            this.form.timestamp = this.getCurrentTimestamp();

            const response = await $.ajax({
                type: "POST",
                url: process.env.ZAP_TFN,
                data: this.form,
                dataType: "json",
            });

            return response;
        },
        restoreSave() {
            const saved = JSON.parse(this.localStorage.getItem("tfn-form-save"));

            if (saved) {
                this.form = { ...this.form, ...saved };
            }
        }
    },
    created() {
        if ((process.browser || process.client) && process.env && !!process.env.MAINTENANCE) {
            window.location.assign("https://kudosity.com/contact-us?upgrade-support=1&url=" + window.location.href);
        }
        if (process.browser) {
            this.localStorage = !("localStorage" in window) ? storage : window.localStorage;

            this.restoreSave();
        }
    }
};
